module.exports = __webpack_public_path__ + "static/media/refer-friend.4801e6d7.png";